import React from 'react';

import ColumnLayout from '../core/column-layout.js';

const List = ({ data }) => {
  const { title, entries } = data;

  const breakpoints = {
    2: 'hide--m',
    3: 'show--m',
  };

  return (
    <div className="mb2 pt1 container--xl mxa px15">
      {title && title.length > 0 && <h6 className="caps pb2">{title}</h6>}
      {Object.keys(breakpoints).map(count => (
        <div key={`col-${count}`} className={`x pb2 ${breakpoints[count]}`}>
          <ColumnLayout>
            {chunkify(entries, count, true).map(column => (
              <div
                className="f1 s4 pr1"
                key={Math.random()}
                style={{ lineHeight: '1.15rem' }}
              >
                {column.map(item => (
                  <div key={Math.random()} className="pb05">
                    {item}
                    <br />
                  </div>
                ))}
              </div>
            ))}
          </ColumnLayout>
        </div>
      ))}
    </div>
  );
};

function chunkify(a, n, balanced) {
  if (n < 2) return [a];

  const len = a.length;
  const out = [];
  let i = 0;
  let size;

  if (len % n === 0) {
    size = Math.floor(len / n);
    while (i < len) {
      out.push(a.slice(i, (i += size)));
    }
  } else if (balanced) {
    while (i < len) {
      size = Math.ceil((len - i) / n--);
      out.push(a.slice(i, (i += size)));
    }
  } else {
    n--;
    size = Math.floor(len / n);
    if (len % size === 0) size--;
    while (i < size * n) {
      out.push(a.slice(i, (i += size)));
    }
    out.push(a.slice(size * n));
  }

  return out;
}

export default List;
